var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"no-data-text":_vm.noDataPlaceholder},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_vm._t("append")]},proxy:true}],null,true)},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }